import { useMemo } from 'react'
import { getBookedSlotStripColor } from '../../DayViewCalendarComponent'

/**
 * Custom hook to calculate and memoize booked slot styles
 * @param {Object} bookedSlot - The booked slot data
 * @param {boolean} isSlotBookedInOtherClinic - Whether slot is blocked
 * @returns {Object} Object containing calculated colors and styles
 */
export const useBookedSlotStyles = (bookedSlot, isSlotBookedInOtherClinic, showAsNormalForMentorOrSupport = false) => {
  return useMemo(() => {
    const colors = getBookedSlotStripColor(bookedSlot, isSlotBookedInOtherClinic, showAsNormalForMentorOrSupport)

    return {
      // Color properties
      background: colors?.background,
      borderColor: colors?.borderColor,
      fontColor: colors?.fontColor,
      leftStripColor: colors?.leftStripColor,
      leftStripBorderColor: colors?.leftStripBorderColor,
      leftStripTextColor: colors?.leftStripTextColor,
      visitTextColor: colors?.visitTextColor,

      // Calculated styles
      leftStripStyle: {
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        padding: '6px 8px',
        borderRight: `2px solid ${colors?.leftStripBorderColor}`,
        background: colors?.leftStripColor,
        borderRadius: '0 4px 4px 0',
        boxShadow: 'inset -2px 0 4px rgba(0, 0, 0, 0.05)',
      },

      visitCornerStyle: {
        position: 'absolute',
        top: 0,
        right: 0,
        borderBottom: `1px solid ${colors?.leftStripBorderColor}`,
        borderLeft: `1px solid ${colors?.leftStripBorderColor}`,
        borderRadius: '0px 0px 0px 10px',
        background: colors?.leftStripColor,
        padding: '0px 10px',
        fontSize: '12px',
      },

      patientInfoStyle: {
        color: colors?.visitTextColor,
      },
    }
  }, [bookedSlot, isSlotBookedInOtherClinic, showAsNormalForMentorOrSupport])
}